module.exports = __webpack_public_path__ + "img/cooperate.ccbb0a2a.png";